(function () {
  'use strict';

  if (window.__GG_CART_DRAWER_V2__) return;
  window.__GG_CART_DRAWER_V2__ = true;

  var drawer, panel, imageWrap, image, title, subtitle, price;
  var autoCloseTimer = null;
  var lastActiveElement = null;
  var lastClickDetail = null;
  var lastOpenAt = 0;

  function qs(selector) {
    return document.querySelector(selector);
  }

  function init() {
    drawer = qs('[data-mas-cart-drawer]');
    if (!drawer) return false;
    panel = drawer.querySelector('.mas-cart-drawer__panel');
    imageWrap = drawer.querySelector('[data-mas-cart-drawer-image-wrap]');
    image = drawer.querySelector('[data-mas-cart-drawer-image]');
    title = drawer.querySelector('[data-mas-cart-drawer-product]');
    subtitle = drawer.querySelector('[data-mas-cart-drawer-subtitle]');
    price = drawer.querySelector('[data-mas-cart-drawer-price]');
    return true;
  }

  function cleanText(value) {
    if (window.GGCartCore && typeof window.GGCartCore.cleanText === 'function') return window.GGCartCore.cleanText(value);
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getText(root, selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var node = root.querySelector(selectors[i]);
      var value = cleanText(node && node.textContent);
      if (value) return value;
    }
    return '';
  }

  function getImage(root) {
    var images = root.querySelectorAll('img');
    for (var i = 0; i < images.length; i += 1) {
      var src = images[i].getAttribute('src') || images[i].getAttribute('data-src') || '';
      if (src && !/icon|svg/i.test(src)) return src;
    }
    return '';
  }

  function extractDetail(target) {
    if (!target) return null;
    var root = target.closest('[data-product-card], .product-card, product-form-component, .product-page-experience, [data-rb-item], .rb-cinema-v45__item, .gg-flagship__product, .collection-tabs__card') || document;
    return {
      title: getText(root, ['[data-rb-title]', '.rb-cinema-v45__title', '.rb-cinema-v45__name', '.product-title', '.product__title', 'h1', 'h2', 'h3', '.card__heading', '.full-unstyled-link']) || 'Produit ajouté',
      price: getText(root, ['[data-product-price]', '.price-item--sale', '.price-item--regular', '.price', '.rb-cinema-v45__price']) || '',
      image: getImage(root),
      subtitle: 'Ajouté à votre panier'
    };
  }

  function open(detail) {
    if (!init()) return;
    var now = Date.now();
    if (now - lastOpenAt < 450) return;
    lastOpenAt = now;

    detail = detail || lastClickDetail || {};
    lastActiveElement = document.activeElement;
    if (title) title.textContent = detail.title || 'Produit ajouté';
    if (subtitle) subtitle.textContent = detail.subtitle || 'Ajouté à votre panier';
    if (price) price.textContent = detail.price || '—';

    if (image && imageWrap) {
      if (detail.image) {
        image.src = detail.image;
        image.alt = detail.title || 'Produit ajouté';
        imageWrap.hidden = false;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        imageWrap.hidden = true;
      }
    }

    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mas-cart-drawer-open');
    clearTimeout(autoCloseTimer);
    if (panel) panel.focus();
    autoCloseTimer = setTimeout(close, 3200);
  }

  function close() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mas-cart-drawer-open');
    clearTimeout(autoCloseTimer);
    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var addButton = event.target.closest('[data-rb-add], [data-gg-global-add-to-cart], [data-add-to-cart], [data-gg-add-to-cart], button[name="add"], .gg-flagship__product-button');
    if (addButton) lastClickDetail = extractDetail(addButton);
    if (event.target.closest('[data-mas-cart-close]')) close();
  }, true);

  document.addEventListener('ggcart:item-added', function (event) {
    open((event.detail && event.detail.drawer) || lastClickDetail || {});
  });

  document.addEventListener('mas:open-drawer', function (event) {
    open(event.detail || lastClickDetail || {});
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') close();
  });
})();
